<template>
  <v-chart 
    :forceFit="true" 
    :height="height" 
    :data="lineData" 
    :scale="scale" 
    padding="auto"
  >
    <v-tooltip />
    <v-axis 
      dataKey="date"
      :line="{stroke: 'rgba(255,255,255,0.7)'}" 
      :tickLine="{stroke: 'rgba(255,255,255,0.7)'}"
      :label="{
        textStyle: { fill: '#fff'}, 
        formatter: labelFormat
      }"
    />
    <v-axis 
      dataKey="value" 
      :line="{stroke:'rgba(255,255,255,0.7)'}" 
      :tickLine="{stroke:'rgba(255,255,255,0.7)'}"
      :grid="null" 
      :label="{textStyle: { fill: '#fff'}}"
    />
    <v-smooth-line position="date*value" :color="areaColor" shape="smooth" />
    <v-smooth-area position="date*value" :color="areaColor" shape="smooth" />
  </v-chart>
</template>

<script>
export default {
  name: 'DoubleLineChart',
  components: {},
  props: {
    height: {
      type: Number,
      required: true
    },
    lineData: {
      type: Array,
      default: () => { return [] }
    },
    labelFormat: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      scale: [{ dataKey: 'date', min: 0, max: 1 }],
      // lineColor: ['type', ['#642AF7', '#22E1DB']],
      areaColor: ['type', ['rgba(100,42,247,0.5)', 'rgba(34,225,219,0.5)']]
    }
  },
  computed: {},
  methods: {}
}
</script>

<style>
</style>
